/**
 * Calls revoke-session and turns an HTTP error into a thrown error.
 *
 * openapi-fetch does not throw on a 500: it answers `{ error }`. Without this
 * check the sign-out machine would treat a failed revoke as a success
 * (P23/CC-60 · P25).
 */
export interface RevokeSessionResult {
  error?: unknown;
  response?: { status?: number };
}

export async function revokeSession(
  sessionId: string,
  post: (sessionId: string) => Promise<RevokeSessionResult>,
): Promise<void> {
  const { error, response } = await post(sessionId);
  if (error) {
    throw Object.assign(new Error("revoke-session failed"), {
      status: response?.status,
      cause: error,
    });
  }
}
